module.exports = __webpack_public_path__ + "static/assets/0df593a9ab390c94a18629c3ab5a54d4.svg";